import React from 'react';

import Searcher from 'components/DesignSystem/Searcher';
import Snackbar from 'components/DesignSystem/Snackbar';
import Section from 'components/Meteorology/Shared/ControlPanelSheet/Section';
import OptionRow from 'components/Meteorology/Shared/ControlPanelSheet/OptionRow';
import searchPattern from 'components/Meteorology/Shared/ControlPanelSheet/DetailedView/searchPattern';
import {
  NamedItem, SearchState, SectionState,
} from 'components/Meteorology/Shared/ControlPanelSheet/DetailedView/types';

export default function GroupSection({
  groupedLocations, search, onSearchChange, open, onToggle,
}: SectionState & SearchState & {
  groupedLocations: {
    groups: NamedItem[];
    selectedGroup: NamedItem | undefined;
    setGroup: (id: number) => void;
  };
}) {
  const pattern = searchPattern(search);

  return (
    <Section
      label="Grupo"
      valueText={groupedLocations.selectedGroup?.name}
      open={open}
      onToggle={onToggle}
    >
      <Searcher value={search} onChange={(e) => onSearchChange(e.target.value)} />
      {groupedLocations.groups.length === 0 && (
        <Snackbar className="mt-2">Nenhum grupo disponível</Snackbar>
      )}
      {groupedLocations.groups.filter((g) => pattern.test(g.name)).map((g) => (
        <OptionRow
          key={g.id}
          label={g.name}
          selected={g.id === groupedLocations.selectedGroup?.id}
          onSelect={() => groupedLocations.setGroup(g.id)}
        />
      ))}
    </Section>
  );
}
